<template>
  <div class="sci-page-wrapper" style="font-family: 'Inter', sans-serif;">
    <div class="max-w-5xl mx-auto">
      
      <!-- HEADER -->
      <div class="sci-page-header pb-4">
        <div>
          <button @click="$router.back()" class="flex items-center gap-2 text-slate-500 hover:text-orange-600 transition-colors mb-4 self-start">
            <v-icon small color="inherit">mdi-arrow-left</v-icon>
            <span class="text-[10px] font-bold uppercase tracking-wider">Voltar</span>
          </button>
          <h1 class="sci-page-header-title">{{ id ? 'Editar Grupo' : 'Novo Grupo' }}</h1>
        </div>
      </div>

        <div class="space-y-6 pb-24">
          <v-form ref="form" v-model="valid" lazy-validation autocomplete="off">
            <div class="space-y-6">
              <!-- SEÇÃO 1: INFORMAÇÕES BÁSICAS -->
            <div class="bg-white rounded-xl border border-slate-200 overflow-hidden shadow-sm">
              <div class="px-6 py-4 flex items-center gap-3" style="background-color: #333333;">
                <v-icon color="orange" small>mdi-form-textbox</v-icon>
                <h2 class="text-white font-bold uppercase tracking-widest text-[11px]">INFORMAÇÕES DO GRUPO</h2>
              </div>
              
              <div class="p-8">
                <v-row dense>
                  <v-col cols="12">
                     <label class="block text-[10px] font-black text-slate-400 uppercase tracking-widest mb-1 ml-1">Nome do Grupo</label>
                     <v-text-field
                       v-model="data.group_name"
                       placeholder="EX: ADMINISTRADORES, FRENTISTAS..."
                       solo
                       flat
                       dense
                       hide-details
                       class="custom-input"
                       :rules="fieldRules"
                       required
                     ></v-text-field>
                  </v-col>
                </v-row>
              </div>
            </div>

            <!-- SEÇÃO 2: PERMISSÕES -->
            <div class="bg-white rounded-xl border border-slate-200 overflow-hidden shadow-sm">
              <div class="px-6 py-4 flex items-center gap-3" style="background-color: #333333;">
                <v-icon color="orange" small>mdi-shield-lock-outline</v-icon>
                <h2 class="text-white font-bold uppercase tracking-widest text-[11px]">PERMISSÕES DE ACESSO</h2>
              </div>
              
              <div class="p-6">
                <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                  <div 
                    v-for="(routes, i) in this.data.group_permissions" 
                    :key="i"
                    class="group relative flex items-center justify-between p-4 bg-slate-50 hover:bg-white rounded-xl border border-slate-100 hover:border-orange-200 hover:shadow-md transition-all duration-300 cursor-pointer"
                    @click="routes.show = !routes.show"
                  >
                    <div class="flex items-center gap-3">
                      <div :class="routes.show ? 'bg-orange-100 text-orange-600' : 'bg-slate-200 text-slate-400'" class="w-8 h-8 rounded-lg flex items-center justify-center transition-colors">
                        <v-icon small color="currentColor">{{ routes.show ? 'mdi-check-circle' : 'mdi-circle-outline' }}</v-icon>
                      </div>
                      <span :class="routes.show ? 'text-slate-700 font-bold' : 'text-slate-400 font-medium'" class="text-[11px] uppercase tracking-wider transition-all">
                        {{ routes.title }}
                      </span>
                    </div>

                    <div class="flex items-center">
                      <div 
                        :class="routes.show ? 'bg-emerald-500' : 'bg-slate-300'" 
                        class="w-8 h-4 rounded-full relative transition-colors duration-300"
                      >
                        <div 
                          :class="routes.show ? 'translate-x-4' : 'translate-x-0'" 
                          class="absolute top-0.5 left-0.5 w-3 h-3 bg-white rounded-full shadow-sm transform transition-transform duration-300"
                        ></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- FOOTER INTEGRADO NO ÚLTIMO CARD -->
              <div class="bg-slate-50 px-8 py-5 border-t border-slate-200 flex justify-end items-center gap-4">
                <button 
                  @click="$router.back()" 
                  type="button"
                  class="text-slate-500 hover:text-slate-700 font-bold text-[11px] uppercase px-4 py-2 transition-colors flex-none"
                >
                  Cancelar
                </button>

                <div class="flex-none">
                  <button 
                    @click="validate"
                    type="button"
                    :disabled="loader"
                    class="bg-orange-500 hover:bg-orange-600 disabled:opacity-50 text-white font-bold text-[11px] px-6 py-2.5 rounded shadow-lg hover:shadow-xl transform hover:-translate-y-0.5 transition-all w-auto max-w-max whitespace-nowrap flex items-center gap-2"
                  >
                    <v-icon small color="white" class="mr-1" style="font-size: 14px;">mdi-check</v-icon>
                    <span v-if="loader" class="animate-spin h-3 w-3 border-2 border-white border-t-transparent rounded-full"></span>
                    <span v-else>{{ id ? 'SALVAR ALTERAÇÕES' : 'CONFIRMAR CADASTRO' }}</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </v-form>
      </div>

        <!-- NOTIFICAÇÕES -->
        <v-snackbar
          v-model="snack.show"
          :color="snack.color"
          timeout="3000"
          rounded="lg"
          elevation="24"
        >
          <div class="flex items-center gap-3">
            <v-icon color="white" small>
              {{ snack.color === 'success' ? 'mdi-check-circle' : 'mdi-alert-circle' }}
            </v-icon>
            <span class="text-xs font-bold uppercase tracking-wider">{{ snack.message }}</span>
          </div>
        </v-snackbar>
    </div>
  </div>
</template>

<script>
export default {
  props: ["id"],
  data: () => ({
    valid: false,
    loader: false,
    fieldRules: [(v) => !!v || "Este campo é requerido"],
    snack: {
      show: false,
      message: "",
      color: "success",
    },
    menus: [
      { title: "Dashboard", show: false },
      { title: "Cadastros", show: false },
      { title: "Veículos", show: false },
      { title: "Gerenciar Veiculos", show: false },
      { title: "Gerenciar Máquinas", show: false },
      { title: "Situação da Frota", show: false },
      { title: "Modelos", show: false },
      { title: "Marcas", show: false },
      { title: "Cores", show: false },
      { title: "Proprietario", show: false },
      { title: "Gerenciar Proprietario", show: false },
      { title: "Locador", show: false },
      { title: "Gerenciar Locador", show: false },
      { title: "Depedências", show: false },
      { title: "Tipos de Atendimento", show: false },
      { title: "Tipos de Combustível", show: false },
      { title: "Tipos de Consumo", show: false },
      { title: "Tipos de Vínculo", show: false },
      { title: "Fornecedores", show: false },
      { title: "Gerenciar Fornecedores", show: false },
      { title: "Frentistas", show: false },
      { title: "Gerenciar Frentistas", show: false },
      { title: "Usuários", show: false },
      { title: "Gerenciar Usuários", show: false },
      { title: "Grupos de Acesso", show: false },
      { title: "Prefeituras", show: false },
      { title: "Gerenciar Prefeituras", show: false },
      { title: "Licitaçōes", show: false },
      { title: "Gerenciar Licitaçōes", show: false },
      { title: "Tipos de Licitação", show: false },
      { title: "Modelos de Licitação", show: false },
      { title: "Cartão Black", show: false },
      { title: "Gerenciar Clientes", show: false },
      { title: "Gerenciar Cartões", show: false },
      { title: "Financeiro", show: false },
      { title: "Faturamento", show: false },
      { title: "Motoristas", show: false },
      { title: "Gerenciar Motoristas", show: false },
      { title: "Abastecimento", show: false },
      { title: "Conferência", show: false },
      { title: "Abastecer", show: false },
      { title: "Abastecer pelo administrador", show: false },
      { title: "Relatórios pelo administrador", show: false },
      { title: "Conferências pelo administrador", show: false },
      { title: "Bloqueados", show: false },
      { title: "Reajuste", show: false },
      { title: "Relatório Genérico", show: false },
      { title: "Retroatividade", show: false },
      { title: "Relatório TCE", show: false },
      { title: "Relatório TCE: Proprietario Frota", show: false },
      { title: "Relatório TCE: Locador Prestador", show: false },
      { title: "Relatório TCE: Veículos", show: false },
      { title: "Relatório TCE: Máquinas", show: false },
      { title: "Relatório TCE: Situação Frota", show: false },
      { title: "Relatório TCE: Abastecimento", show: false },
      { title: "Nota Fiscal", show: false },
      { title: "Peças e Serviços", show: false },
      { title: "Fornecedores | Peças e Serviços", show: false },
      { title: "Gerenciar Fornecedores | Peças e Serviços", show: false },
      { title: "Licitações | Peças e Serviços", show: false },
      { title: "Gerenciar Licitações | Peças e Serviços", show: false },
      { title: "Lançar Notas | Peças e Serviços", show: false },
      { title: "Gerenciar Notas | Peças e Serviços", show: false },
      { title: "Ordem de Serviços | Peças e Serviços", show: false },
      { title: "Gerenciar OS | Peças e Serviços", show: false },
      { title: "Liberação de OS | Peças e Serviços", show: false },
      { title: "Gerenciar Liberação de OS | Peças e Serviços", show: false },
      { title: "Relatórios | Peças e Serviços", show: false },
      { title: "Relatório Analítico | Peças e Serviços", show: false },
      { title: "Relatório Sintético | Peças e Serviços", show: false },
      { title: "Abastecimentos Concluídos", show: false },
      { title: "Histórico de Abastecimentos", show: false },
      { title: "Abastecimentos Autorizados", show: false },
      { title: "Abastecimentos Extras", show: false },
    ],
    data: {
      group_id: null,
      group_name: "",
      group_permissions: [],
    },
  }),
  created() {
    if (this.id) {
      this.$store.dispatch("setLoader", true);
      this.$http.get(`access-groups/${this.id}`).then((r) => {
        this.data = r.data[0];
        const returnedMenus = JSON.parse(r.data[0].group_permissions);

        const norm = t => t ? t.replace(/Almoxarifado/g, "Peças e Serviços").replace(/Almoxarifados/g, "Peças e Serviços") : '';
        returnedMenus.map((p) => {
          this.menus.map((m) => {
            (norm(m.title) == norm(p.title) || (m.title == "Abastecimentos Concluídos" && p.title == "Abastecimentos")) ? (m.show = p.show) : false;
          });
        });

        this.data.group_permissions = this.menus;
        this.$store.dispatch("setLoader", false);
      });
    } else {
      this.data.group_permissions = this.menus;
      this.$store.dispatch("setLoader", false);
    }
  },
  methods: {
    validate() {
      this.loader = true;
      this.$store.dispatch("setLoader", this.loader);
      if (this.$refs.form.validate() && this.data.group_name) {
        this.createOrUpdate();
      } else {
        this.snack.show = true;
        this.snack.color = "warning";
        this.snack.message = "Atencão: O nome do grupo é obrigatório!";
        this.loader = false;
        this.$store.dispatch("setLoader", false);
      }
    },
    createOrUpdate() {
      this.loader = true;
      const payload = { ...this.data };
      payload.group_permissions = JSON.stringify(payload.group_permissions);
      
      if (this.id) {
        this.$store.dispatch("setLoader", this.loader);
        this.$http
          .put(`/access-groups/${this.id}`, payload)
          .then((r) => {
            this.snack.show = true;
            this.snack.message = r.data.result;
            this.snack.color = "success";
            setTimeout(() => {
              this.$router.push("/access-groups");
            }, 1000);
          })
          .catch((e) => {
            this.snack.show = true;
            this.snack.message = e.message;
            this.snack.color = "error";
            this.loader = false;
            this.$store.dispatch("setLoader", false);
          });
      } else {
        this.$store.dispatch("setLoader", this.loader);
        this.$http
          .post("/access-groups", payload)
          .then((r) => {
            this.snack.show = true;
            this.snack.message = r.data.result;
            this.snack.color = "success";
            setTimeout(() => {
              this.$router.push("/access-groups");
            }, 1000);
          })
          .catch((e) => {
            this.snack.show = true;
            this.snack.message = e.message;
            this.snack.color = "error";
            this.loader = false;
            this.$store.dispatch("setLoader", false);
          });
      }
    },
  },
};
</script>

<style scoped>
.min-h-screen { min-height: 100vh; }
.bg-slate-50 { background-color: #f8fafc; }
.border-slate-200 { border-color: #e2e8f0; }
.text-slate-400 { color: #94a3b8; }
.text-slate-500 { color: #64748b; }
.text-slate-700 { color: #334155; }

.grid { display: grid; }
.grid-cols-1 { grid-template-columns: repeat(1, minmax(0, 1fr)); }
@media (min-width: 768px) { .md\:grid-cols-2 { grid-template-columns: repeat(2, minmax(0, 1fr)); } }
@media (min-width: 1024px) { .lg\:grid-cols-3 { grid-template-columns: repeat(3, minmax(0, 1fr)); } }
.gap-4 { gap: 1rem; }

.shadow-lg { box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05); }
.shadow-orange-500\/20 { box-shadow: 0 10px 15px -3px rgba(249, 115, 22, 0.2); }

.custom-input ::v-deep .v-input__control { min-height: 48px !important; }
.custom-input ::v-deep .v-input__slot { 
  background-color: #f8fafc !important; 
  border: 1px solid #e2e8f0 !important;
  box-shadow: none !important;
  border-radius: 0.5rem !important;
  padding: 0 12px !important;
  text-transform: uppercase !important;
  font-weight: 700 !important;
  color: #334155 !important;
}
.custom-input ::v-deep input {
    text-transform: uppercase !important;
}
</style>
